import * as React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { MdCameraAlt } from "react-icons/md";
import { HiOutlineUpload } from "react-icons/hi";

const RedColorButton = styled(Button)(() => ({
  textTransform: "capitalize",
  color: "#A7ABA9",
  fontFamily: "PoppinsMedium",
  outline: "none",
  border: "1px solid #666666",
  borderRadius:"8px",
  backgroundColor: "#fff",
  "&:focus": {
    outline: "none",
  },
  "&:hover": {
    backgroundColor: "#fff",
  },
  "&.Mui-disabled": {
    backgroundColor: "#fff",
    color: "#A7ABA9",
    cursor: "not-allowed",
  },
}));



const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export default function FileUploadButton({ onClick, multiple, accept, placeholder, text, className ,startIcon,endIcon}) {
  return (
    <RedColorButton
      className={className}
      component="label"
      role={undefined}
      variant="contained"
      tabIndex={-1}
      width={"100%"}
      startIcon={startIcon&&<MdCameraAlt color="#666666" />}
      endIcon={endIcon&&<HiOutlineUpload color="#666666" />}
    >
      {text ? (text?.length > 25 ? text?.slice(0, 20) + "...." : text) : placeholder ? placeholder : "Upload File"}
      <VisuallyHiddenInput
        type="file"
        accept={accept ? accept : "application/pdf"}
        onChange={(event) => onClick(event)}
        multiple={multiple ? multiple : false}
      />
    </RedColorButton>
  );
}
